// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"EllipsedLabel_tooltip__3BxUz","lineClamp":"EllipsedLabel_lineClamp__2sMQO"};